import Utils from "../../Utils"

export const actions = {
	setCurrentUser: 'SET_CURRENT_USER',
	setProyectos: 'SET_PROYECTOS'
}

export const setCurrentUser = payload => ({
	type: actions.setCurrentUser,
	payload
})

export const setProyectos = payload => ({
	type: actions.setProyectos,
	payload
})


export const checkToken = () => (
	async (dispatch, getState) => {
		const token = Utils.GetAuthToken()
		if(token == null) {
			return;
		}
		//dispatch(setLoadingHistorial(true))
		try {
			const { data } = await Utils.API.checkToken()
			dispatch(setCurrentUser(data))
		} catch(err) {
			console.error(err)
			Utils.AlertError(err, "No se pudo cargar tu historial de Pagos")
		}
	}
)


export const getProyectos = () => (
	async (dispatch, getState) => {
		try {
			const { data } = await Utils.API.ListarProyectos()
			dispatch(setProyectos(data))
		} catch(err) {
			console.error(err)
			Utils.AlertError(err, "No se pudo cargar la lista de proyectos")
		}
	}
)